import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useEffect, useRef } from 'react'

import classNames from '../../utils/classNames'
import closeModal from '../../utils/closeModal'
import { getBrowserName } from '../../utils/getBrowserName'
import Icon from '../icon'
import Modal from './modal'

const browserName = getBrowserName()

const PWATutorial = ({ pwa_tutorial }: { pwa_tutorial: string }) => {
  const modal = useModal()
  const videoRef = useRef<HTMLVideoElement>(null)

  // The walkthrough dismisses itself when it finishes, so players land back on
  // the page they were installing from instead of on a stopped video they have
  // to close by hand. Matches fun_88_global's tutorial.
  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const handleEnded = () => closeModal(modal)

    video.addEventListener('ended', handleEnded)
    return () => video.removeEventListener('ended', handleEnded)
  }, [])

  return (
    <Modal
      id="pwa-tutorial"
      hideOverlay
      isFullScreen
      containerStyle="!px-0 !py-0 !mx-0 !my-0 !bg-black !border-none !shadow-none">
      <button
        className="absolute top-2 left-2 z-10 bg-gray-600 bg-opacity-50 p-3 rounded-full"
        onClick={() => closeModal(modal)}>
        <Icon className="w-3 h-3 fill-white" id="close" />
      </button>
      <video
        ref={videoRef}
        preload="auto"
        playsInline
        controls
        autoPlay
        // iOS refuses to autoplay a video with sound, and every iPhone browser
        // lands on 'safari' here. Today's iOS clip carries no audio track, so
        // it would autoplay either way — this keeps it playing if a future
        // recording ships with one.
        muted={browserName === 'opera' || browserName === 'safari'}
        className={classNames(
          'relative bottom-0 mx-auto w-auto',
          browserName === 'safari' ? 'h-[calc(100%-60px)] mt-[60px]' : 'h-full',
        )}>
        <source src={pwa_tutorial} type="video/mp4" />
      </video>
    </Modal>
  )
}

export default NiceModal.create(PWATutorial)
